module.exports = __webpack_public_path__ + "fonts/SuisseIntl-RegularItalic.263b718.woff";